import { request } from "../request";
var BaseApiService = (function () {
    function BaseApiService(baseUrl) {
        this.baseUrl = baseUrl;
    }
    BaseApiService.prototype.emptyStringToNull = function (object) {
        var _this = this;
        if (object === "") {
            return null;
        }
        if (object instanceof Array) {
            return object.map(function (item) { return _this.emptyStringToNull(item); });
        }
        if (!!object && typeof object === "object" && !(object instanceof Date)) {
            var newObject = {};
            for (var key in object) {
                newObject[key] = this.emptyStringToNull(object[key]);
            }
            return newObject;
        }
        return object;
    };
    BaseApiService.prototype.serializeQuery = function (params, options) {
        var _this = this;
        if (typeof params === "undefined" || params === null) {
            return "";
        }
        var isTopLevel = options.isTopLevel, prefix = options.prefix;
        var query = Object.keys(params).map(function (key) {
            var value = params[key];
            var actualKey = "";
            if (params.constructor === Array) {
                if (typeof value === "object") {
                    actualKey = "".concat(prefix, "[").concat(key, "]");
                }
                else {
                    actualKey = "".concat(prefix, "[]");
                }
            }
            else if (params.constructor === Object) {
                actualKey = prefix ? "".concat(prefix, "[").concat(key, "]") : key;
            }
            if (typeof value === "object") {
                return _this.serializeQuery(value, { isTopLevel: false, prefix: actualKey });
            }
            return "".concat(actualKey, "=").concat(encodeURIComponent(value));
        });
        if (!query.length) {
            return "";
        }
        return "".concat(isTopLevel ? "?" : "").concat(query.join("&"));
    };
    BaseApiService.prototype.create = function (data) {
        return request("".concat(this.baseUrl), "POST", this.emptyStringToNull(data));
    };
    BaseApiService.prototype.bulkCreate = function (data) {
        var _this = this;
        var sanitizedData = {
            data: data.map(function (item) { return _this.emptyStringToNull(item); })
        };
        return request("".concat(this.baseUrl, "/bulk"), "POST", sanitizedData);
    };
    BaseApiService.prototype.find = function (data) {
        return request("".concat(this.baseUrl).concat(this.serializeQuery(data, {
            isTopLevel: true
        })), "GET");
    };
    BaseApiService.prototype.findOne = function (id, data) {
        return request("".concat(this.baseUrl, "/item/").concat(id).concat(this.serializeQuery(data, {
            isTopLevel: true
        })), "GET");
    };
    BaseApiService.prototype.update = function (data) {
        return request("".concat(this.baseUrl), "PATCH", this.emptyStringToNull(data));
    };
    BaseApiService.prototype.delete = function (data) {
        return request("".concat(this.baseUrl), "DELETE", this.emptyStringToNull(data));
    };
    BaseApiService.prototype.count = function (data) {
        return request("".concat(this.baseUrl, "/count/").concat(this.serializeQuery(data, {
            isTopLevel: true
        })), "GET");
    };
    return BaseApiService;
}());
export { BaseApiService };
//# sourceMappingURL=baseApiService.service.js.map